import React from 'react';
import { ArrowLeft, Building, CreditCard } from 'lucide-react';

interface HeaderSectionProps {
  onBack: () => void;
  onScanCard: () => void;
  editMode?: boolean;
}

export const HeaderSection: React.FC<HeaderSectionProps> = ({ 
  onBack, 
  onScanCard, 
  editMode = false 
}) => {
  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center space-x-3">
          <button onClick={onBack} className="p-2 rounded-full hover:bg-gray-100">
            <ArrowLeft className="w-5 h-5 text-gray-600" />
          </button>
          <div className="flex items-center space-x-2">
            <Building className="w-6 h-6 text-blue-600" />
            <h1 className="text-lg font-semibold text-gray-800">
              {editMode ? 'Edit Outlet' : 'Add New Outlet'}
            </h1>
          </div>
        </div>
        <button
          onClick={onScanCard}
          className="p-2 rounded-full hover:bg-gray-100 transition-colors"
          title="Scan Visiting Card"
        >
          <CreditCard className="w-5 h-5 text-gray-600" />
        </button>
      </div>
    </header>
  );
};

export default HeaderSection;
